<script setup>
import {
	Plus,
	Cat,
	Dog,
} from "../Icons";

const emit = defineEmits();
</script>

<template>
	<button
		class="add-pet"
		@click="emit('addPet')"
	>
		<div class="add-pet__icons">
			<Cat />
			<Dog />
		</div>
		<span>Добавить питомца</span>
		<Plus />
	</button>
</template>

<style lang='scss'>
.add-pet {
	width: 100%;
	height: 64px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	color: #BABABA;
	padding-inline: 20px;
	background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='12' ry='12' stroke='%23BABABAFF' stroke-width='3' stroke-dasharray='10%2c 10' stroke-dashoffset='10' stroke-linecap='square'/%3e%3c/svg%3e");
	border-radius: 12px;
  background-color: #F9F9F9;
	font-weight: 500;
	font-size: 16px;

	& > svg { color: $yellow }

	@include mq($tablet) {
		height: 414px;
		flex-direction: column-reverse;
		justify-content: center;
		gap: 62px;

		& > svg {
			width: 58px;
			height: 58px;
		}
	}
}

.add-pet__icons {
	display: flex;
	align-items: center;
	gap: 16px;

	@include mq($tablet) { display: none }
}
</style>